export const sizeToHeading = {
  xs: 'span',
  'extra-small': 'span',
  sm: 'h5',
  small: 'h5',
  md: 'h4',
  medium: 'h4',
  lg: 'h2',
  large: 'h2',
  xl: 'h1',
  'extra-large': 'h1'
};
export const tagNameToPaddingLeft = {
  span: '500',
  h6: '500',
  h5: '600',
  h4: '700',
  h3: '700',
  h2: '800',
  h1: '800'
};
const tagNameToMarginBottom = {
  span: '200',
  h6: '0',
  h5: '0',
  h4: '0',
  h3: '0',
  h2: '0',
  h1: '0'
};
const tagNameToIconSize = {
  span: '100',
  h6: '100',
  h5: '200',
  h4: '300',
  h3: '400',
  h2: '500',
  h1: '500'
};
export const getPaddingLeft = (size, titleTagName) => {
  if (titleTagName) {
    return tagNameToPaddingLeft[titleTagName];
  }
  if (size) {
    return tagNameToPaddingLeft[sizeToHeading[size]];
  }
  return tagNameToPaddingLeft['span'];
};
export const getMarginBottom = (size, titleTagName) => {
  if (titleTagName) {
    return tagNameToMarginBottom[titleTagName];
  }
  if (size) {
    return tagNameToMarginBottom[sizeToHeading[size]];
  }
  return tagNameToMarginBottom['span'];
};
export const getIconSize = (size, titleTagName) => {
  if (titleTagName) {
    return tagNameToIconSize[titleTagName];
  }
  if (size) {
    return tagNameToIconSize[sizeToHeading[size]];
  }
  return tagNameToIconSize['span'];
};